import { useCallback } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import ResourceDefault from './ResourceSwitch/ResourceDefault';
import ObligationDefault from './ResourceSwitch/ObligationDefault';
import BlockChangeResourceCheckbox from './ResourceContainerElements/BlockChangeResourceCheckbox';

export default function ElementContainer({ elementID, view }) {
  const resourcesCheckbox = useSelector(
    (state) => state.currentPage?.options?.resourcesCheckbox,
  );

  const ResourcesSwitch = useCallback(() => {
    switch (view) {
      default:
      case 'resource':
        return <ResourceDefault elementID={elementID} />;
      case 'obligation':
        return <ObligationDefault elementID={elementID} />;
    }
  }, [elementID, view]);

  return (
    <Container className="pt-2">
      <PreElement>
        {resourcesCheckbox ? (
          <BlockChangeResourceCheckbox resourceID={elementID} />
        ) : null}
      </PreElement>
      <ResourcesSwitch />
    </Container>
  );
}
const Container = styled.div`
  display: grid;
  grid-template-columns: 24px 1fr;
`;
const PreElement = styled.div`
  height: 112px;
  display: flex;
  align-items: center;
`;
